import { Component } from '@angular/core';
import { TablerosBiService } from './services/tableros-bi.service';
import { ReportBI } from '../../../interfaces/reportes-bi.response.interface';

@Component({
    selector: 'app-tableros-bi',
    templateUrl: './tableros-bi.component.html',
    styleUrls: ['./tableros-bi.component.css'],
})
export class TablerosBiComponent {
    reports: ReportBI[];
    constructor(private boardService: TablerosBiService) {}

    ngOnInit(): void {
        this.mostrarTableros();
    }

    mostrarTableros() {
        this.boardService.GetBoards().subscribe(
            (reports) => {
                this.reports = reports;
            },
            (error) => {
                console.error('Error al cargar los tableros de BI', error);
            }
        );
    }
}
